import React from 'react';

import {useStateValue} from "./state";

export const ActionButton = (msg, req) => {

    const [, dispatch] = useStateValue();

    let request = {
        type: 'appendLog',
        newMsg: msg.msg
    };

    if(msg.msg === 'clear log') {
        request.type = 'clearLog';
    }

    return (<button className='ActionButton'
                type="button"
                onClick={() => dispatch(request) }
            >
                {msg.msg}
            </button> );

};
